import React from 'react'
import SchoolExploreCourses from '../../features/school/SchoolExploreCourses'

const SchoolExploreCoursesPage = () => {
  return (
   <SchoolExploreCourses/>
  )
}

export default SchoolExploreCoursesPage
